import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";
import { I18nProvider } from "@/lib/i18n";
import ProtectedRoute from "@/components/ProtectedRoute";

import HomePage from "@/pages/Home";
import LoginPage from "@/pages/Login";
import RegisterPage from "@/pages/Register";
import VerifyEmailPage from "@/pages/VerifyEmail";
import { CapabilitiesPage, IndustriesPage } from "@/pages/CapabilitiesAndIndustries";
import { HowItWorks, AboutPage, FaqPage, ContactPage, TermsPage, PrivacyPage, ConfidentialityPage } from "@/pages/StaticPages";

import DashboardHome from "@/pages/dashboard/Home";
import NewRequest from "@/pages/dashboard/NewRequest";
import RequestsList from "@/pages/dashboard/RequestsList";
import RequestDetail from "@/pages/dashboard/RequestDetail";
import OrdersList from "@/pages/dashboard/OrdersList";
import OrderDetail from "@/pages/dashboard/OrderDetail";
import { RFQsList, RFQDetail } from "@/pages/dashboard/RFQs";
import { QuotationsList, PartLibrary, NotificationsList } from "@/pages/dashboard/Misc";
import { WorkshopsAdmin, UsersAdmin, FactoriesAdmin, AnalyticsPage } from "@/pages/dashboard/Admin";
import { InspectionsList, QualityReportsList } from "@/pages/dashboard/Inspections";
import WatermarksAdmin from "@/pages/dashboard/Watermarks";

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/capabilities" element={<CapabilitiesPage />} />
            <Route path="/industries" element={<IndustriesPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/confidentiality" element={<ConfidentialityPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/verify-email" element={<VerifyEmailPage />} />

            {/* Protected app routes */}
            <Route path="/app" element={<ProtectedRoute><DashboardHome /></ProtectedRoute>} />
            <Route path="/app/new-request" element={<ProtectedRoute roles={["factory_customer"]}><NewRequest /></ProtectedRoute>} />
            <Route path="/app/requests" element={<ProtectedRoute><RequestsList /></ProtectedRoute>} />
            <Route path="/app/requests/:id" element={<ProtectedRoute><RequestDetail /></ProtectedRoute>} />
            <Route path="/app/orders" element={<ProtectedRoute><OrdersList /></ProtectedRoute>} />
            <Route path="/app/orders/:id" element={<ProtectedRoute><OrderDetail /></ProtectedRoute>} />
            <Route path="/app/rfqs" element={<ProtectedRoute roles={["workshop_partner"]}><RFQsList /></ProtectedRoute>} />
            <Route path="/app/rfqs/:id" element={<ProtectedRoute roles={["workshop_partner"]}><RFQDetail /></ProtectedRoute>} />
            <Route path="/app/quotations" element={<ProtectedRoute><QuotationsList /></ProtectedRoute>} />
            <Route path="/app/part-library" element={<ProtectedRoute roles={["factory_customer"]}><PartLibrary /></ProtectedRoute>} />
            <Route path="/app/notifications" element={<ProtectedRoute><NotificationsList /></ProtectedRoute>} />
            <Route path="/app/inspections" element={<ProtectedRoute roles={["inspector", "admin", "operations_employee"]}><InspectionsList /></ProtectedRoute>} />
            <Route path="/app/quality-reports" element={<ProtectedRoute roles={["inspector", "admin"]}><QualityReportsList /></ProtectedRoute>} />
            <Route path="/app/workshops" element={<ProtectedRoute roles={["admin", "operations_employee"]}><WorkshopsAdmin /></ProtectedRoute>} />
            <Route path="/app/factories" element={<ProtectedRoute roles={["admin"]}><FactoriesAdmin /></ProtectedRoute>} />
            <Route path="/app/users" element={<ProtectedRoute roles={["admin"]}><UsersAdmin /></ProtectedRoute>} />
            <Route path="/app/analytics" element={<ProtectedRoute roles={["admin", "operations_employee"]}><AnalyticsPage /></ProtectedRoute>} />
            <Route path="/app/watermarks" element={<ProtectedRoute roles={["admin"]}><WatermarksAdmin /></ProtectedRoute>} />

            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
